module.exports = __webpack_public_path__ + "static/media/IMG_0009.e952112d.jpg";